import {
  Box,
  Button,
  CircularProgress,
  CircularProgressProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  API_URL,
  BootstrapTooltip,
  calculateDates,
  ConvertToMiladiDateDB,
  ConvertToShamsiDate,
  handleSendMessage,
} from "../../utilities";
import {
  DataGrid,
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridRowSelectionModel,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useCallback, useEffect, useRef, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import PopoverComponent from "../../components/PopoverComponent";
import SkeltonProgress from "../../components/SkeltonProgress";
import { IAppUser } from "src/interface/IUser";
import { TypeUser } from "src/interface/enum/TypeUser";
import NewAgreement from "./new-agreement";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";

import ShowAgreementInfo from "./components/show-info/show-agreement-info";
import { IAgreement } from "src/interface/IAgreement";
import { FollowUpType } from "src/interface/enum/FollowUpType";
import { IService } from "src/interface/IService";
import { StatusGlobal } from "src/interface/enum/StatusGlobal";
import { IFollowUpGroups } from "src/interface/IFollowUpGroups";
import { IFollowupSchedule } from "src/interface/IFollowupSchedule";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import AddAlarmIcon from "@mui/icons-material/AddAlarm";
import { IAppUserWebSystem } from "src/interface/IAppUserWebSystem";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { getRoutes } from "src/utilities/routes";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteIcon from "@mui/icons-material/Delete";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CancelIcon from "@mui/icons-material/Cancel";
import { ITransaction } from "src/interface/ITransaction";
import { TransactionType } from "src/interface/enum/TransactionType";
import AgreementServiceReportDialog from "./components/AgreementServiceReportDialog";
import { PermissionAction } from "../../components/PermissionActions";
import { usePermissions } from "../../utilities/permissions";
import PageTitle from "../../components/PageTitle";
const Agreements = () => {
  const Routes = getRoutes();
  const notifications = useNotifications();
  const [getAgreeServices, setAgreeServices] = useState<IAgreement>(
    {} as IAgreement
  );
  const { user } = useAuth();
  const { canCreate, canEdit, canDelete, canView } = usePermissions();

  const [data, setData] = useState<IAgreement[]>([]);
  // const { mutateAsync: getAgreements, isPending: isPendingAgreements } =
  //   useMutation({
  //     mutationFn: async () => {
  //       const response = await fetch(Routes.AgreementsRoutes, {
  //         method: "Get",
  //         headers: {
  //           Accept: "*/*",
  //           "Content-Type": "application/json-patch+json",
  //           Authorization: `Bearer ${user?.token || ""}`,
  //         },
  //       });

  //       return await response.json();
  //     },
  //     onSuccess: (responseData: IAgreement[]) => {
  //       responseData && responseData.length && setData(responseData);
  //     },
  //     onError: (error) => {
  //       notifications.show("خطا در دریافت اطلاعات", {
  //         severity: "error",
  //         autoHideDuration: 3000,
  //       });
  //       console.log("eee", error);
  //     },
  //   });

  const [rowCount, setRowCount] = useState<number>(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [rows, setRows] = useState<IAgreement[]>([]);

  const { mutateAsync: getAgreements, isPending: isPendingAgreements } =
    useMutation({
      mutationFn: async () => {
        const url = `${Routes.AgreementsRoutes}by-filter?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}${quickFilterValue ? `&filter=${encodeURIComponent(quickFilterValue)}` : ""}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token || ""}`,
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
      },
      onSuccess: (responseData: {
        items: IAgreement[];
        totalCount: number;
      }) => {
        if (responseData && responseData.items) {
          setRows(responseData.items);
          setRowCount(responseData.totalCount);
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت قراردادها", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.error("Error fetching agreements:", error);
      },
    });

  const { mutateAsync: getAgreementById, isPending: isPendingAgreementById } =
    useMutation({
      mutationFn: async (id: number) => {
        const response = await fetch(Routes.AgreementsRoutes + id, {
          method: "Get",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token || ""}`,
          },
        });

        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log("eee", error);
      },
    });

  const [getCustomers, setCustomers] = useState<IAutoCompleteLabelValue[]>([]);

  const { mutateAsync: getCustomersData, isPending: isPendingCustomers } =
    useMutation({
      mutationFn: async () => {
        const response = await fetch(
          `${Routes.UsersRoutes}getByRole/${TypeUser.CUSTOMER}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json", // "Aceept" رو به "Accept" اصلاح کردم
              "Content-Type": "application/json-patch+json", // اضافه کردم برای سازگاری
              Authorization: `Bearer ${user?.token || ""}`,
            },
          }
        );

        return await response.json();
      },
      onSuccess: (responseData: IAppUser[]) => {
        if (responseData && responseData.length) {
          const transformedData = responseData
            .filter((item: IAppUser) => item.parentRef === null)
            .map((item: IAppUser) => ({
              label:
                item.lName +
                " " +
                item.fName +
                " " +
                item.coName +
                " " +
                item.caseNumber,
              value: item.id,
            }));
          setCustomers(transformedData);
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات مشتریان", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log("Error fetching customers:", error);
      },
    });

  const [openNewAgreement, setOpenNewAgreement] = useState<boolean>(false);
  const [openAgreementInfo, setOpenAgreementInfo] = useState<boolean>(false);
  const [openCancelDialog, setOpenCancelDialog] = useState<boolean>(false);
  const [cancelTarget, setCancelTarget] = useState<IAgreement | null>(null);
  const [cancelDate, setCancelDate] = useState<Date | null>(null);

  // useEffect(() => {
  //   data && setRows(data);
  // }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
  const Reoutes = getRoutes();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Reoutes.TransactionRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleTransaction = async (params: any) => {
    const NewTransaction: ITransaction = {
      agreementId: params.row.id,
      amount: params.row.price,
      description: "بابت قرارداد",
      customerRef: params.row.customerRef,
      isDebit: true,
      transactionDate: params.row.startedAt && new Date(params.row.startedAt),
      transactionType: TransactionType.Contractual,
    };
    const res = await insertAsync(NewTransaction);
    if (res.status === true) {
      handleSendMessage(
        notifications,
        "سند بدهکاری با موفقیت صادر شد",
        "success"
      );
      await getAgreements();
    }
  };

  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: number
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setAgreementId(id);
  };

  const { mutateAsync: renewAgreementAsync, isPending: isRenewPending } =
    useMutation({
      mutationFn: async (agreementId: number) => {
        const res = await fetch(
          `${Routes.AgreementsRoutes}${agreementId}/renew`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${user?.token}`,
            },
          }
        );
        let data: any = null;
        try {
          data = await res.json();
        } catch {
          data = null;
        }
        if (!res.ok) throw new Error(data?.data ?? "خطا در تمدید قرارداد");
        return data;
      },
      onSuccess: async () => {
        handleSendMessage(
          notifications,
          "قرارداد با موفقیت تمدید شد و به لیست اضافه شد.",
          "success"
        );
        await getAgreements();
      },
      onError: (err: Error) => {
        handleSendMessage(
          notifications,
          err.message || "خطا در تمدید قرارداد",
          "error"
        );
      },
    });

  const handleRenewClick = (id: number) => () => {
    renewAgreementAsync(id);
  };

  const { mutateAsync: cancelAgreementAsync, isPending: isCancelPending } =
    useMutation({
      mutationFn: async (payload: { id: number; canceledOn: string }) => {
        const res = await fetch(
          `${Routes.AgreementsRoutes}${payload.id}/cancel`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${user?.token}`,
            },
            body: JSON.stringify({ canceledOn: payload.canceledOn }),
          }
        );
        let data: any = null;
        try {
          data = await res.json();
        } catch {
          data = null;
        }
        if (!res.ok) {
          const msg =
            (typeof data?.data === "string" ? data.data : null) ||
            data?.title ||
            data?.detail ||
            `خطا در فسخ قرارداد (${res.status})`;
          throw new Error(msg);
        }
        return data;
      },
      onSuccess: async () => {
        handleSendMessage(
          notifications,
          "قرارداد با موفقیت فسخ شد و پیگیری‌های بعد از این تاریخ لغو شدند.",
          "success"
        );
        setOpenCancelDialog(false);
        setCancelTarget(null);
        await getAgreements();
      },
      onError: (err: Error) => {
        handleSendMessage(
          notifications,
          err.message || "خطا در فسخ قرارداد",
          "error"
        );
      },
    });

  const handleOpenCancelDialog = (agreement: IAgreement) => {
    setCancelTarget(agreement);
    setCancelDate(new Date());
    setOpenCancelDialog(true);
  };

  const handleCloseCancelDialog = () => {
    setOpenCancelDialog(false);
    setCancelTarget(null);
  };

  const handleConfirmCancel = async () => {
    if (!cancelTarget || !cancelDate) return;
    await cancelAgreementAsync({
      id: cancelTarget.id as number,
      canceledOn: cancelDate.toISOString(),
    });
  };

  const columns: GridColDef[] = [
    {
      field: "serviceItemsType",
      headerName: "عملیات",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: false,
      minWidth: 200,
      type: "actions",
      getActions: (params) => {
        const actions = [];

        // افزودن پیگیری - فقط برای کسانی که دسترسی create دارند
        if (canCreate("followups")) {
          if (params.row.followups.length === 0) {
            actions.push(
              <BootstrapTooltip title="افزودن پیگیری" key="add-followup">
                <GridActionsCellItem
                  icon={
                    <AddAlarmIcon color={isLoading ? "disabled" : "warning"} />
                  }
                  label="افزودن پیگیری"
                  disabled={isLoading}
                  sx={{
                    color: "primary.main",
                  }}
                  onClick={(event) => handleScheduleClick(event, params.row.id)}
                />
              </BootstrapTooltip>
            );
          } else {
            actions.push(
              <BootstrapTooltip title="نمایش پیگیری" key="show-followup">
                <GridActionsCellItem
                  icon={<InsertInvitationIcon color="warning" />}
                  label="نمایش پیگیری"
                  sx={{
                    color: "primary.main",
                  }}
                  //onClick={(event) => handleScheduleClick(event, params.row.id)}
                />
              </BootstrapTooltip>
            );
          }
        }

        // ویرایش قرارداد - فقط برای کسانی که دسترسی edit دارند
        if (canEdit("agreements")) {
          actions.push(
            <BootstrapTooltip title="ویرایش قرارداد" key="agreement-edit">
              <GridActionsCellItem
                icon={<EditNoteIcon color="primary" />}
                label="ویرایش قرارداد"
                className="textPrimary"
                onClick={handleEditClick(params.id as number)}
                color="inherit"
              />
            </BootstrapTooltip>
          );
        }

        // صدور سند بدهکاری - فقط برای کسانی که دسترسی create دارند
        if (canCreate("transactions")) {
          actions.push(
            <BootstrapTooltip
              title="صدور سند بدهکاری قرارداد"
              key="agreement-transaction"
            >
              <GridActionsCellItem
                icon={
                  <LocalAtmIcon
                    color={
                      params.row.transactions.filter(
                        (t: ITransaction) => t.transactionStatus === 1
                      ).length > 0
                        ? "disabled"
                        : "secondary"
                    }
                  />
                }
                label="صدور سند بدهکاری قرارداد"
                sx={{
                  color: "primary.main",
                }}
                disabled={
                  params.row.transactions.filter(
                    (t: ITransaction) => t.transactionStatus === 1
                  ).length > 0
                }
                onClick={() => handleTransaction(params)}
              />
            </BootstrapTooltip>
          );
        }

        // حذف قرارداد - فقط برای کسانی که دسترسی delete دارند
        if (canDelete("agreements")) {
          actions.push(
            <BootstrapTooltip title="حذف قرارداد" key="agreement-delete">
              <GridActionsCellItem
                icon={
                  <DeleteIcon
                    color={
                      params.row.transactions.filter(
                        (t: ITransaction) => t.transactionStatus === 1
                      ).length > 0 || params.row.followups.length > 0
                        ? "disabled"
                        : "error"
                    }
                  />
                }
                label="حذف قرارداد"
                sx={{
                  color: "primary.main",
                }}
                disabled={
                  params.row.transactions.length > 0 ||
                  params.row.followups.length > 0
                }
                onClick={(event) =>
                  handleDeleteClick(event, params.id as number)
                }
              />
            </BootstrapTooltip>
          );
        }

        // تمدید قرارداد — فقط برای قراردادی که خودش قبلاً تمدید نشده (قرارداد فرزند ندارد)
        if (canEdit("agreements") || canCreate("agreements")) {
          // اگر از این قرارداد قبلاً یک قرارداد تمدیدی ساخته شده باشد، دیگر قابل تمدید نیست
          const hasRenewalChildren = params.row.hasRenewalChildren === true;
          actions.push(
            <BootstrapTooltip
              title={
                hasRenewalChildren
                  ? "برای این قرارداد قبلاً یک تمدید ثبت شده و قابل تمدید مجدد نیست"
                  : "تمدید قرارداد"
              }
              key="agreement-renew"
            >
              <span>
                <GridActionsCellItem
                  icon={
                    <AutorenewIcon
                      color={hasRenewalChildren || isRenewPending ? "disabled" : "info"}
                    />
                  }
                  label="تمدید قرارداد"
                  disabled={hasRenewalChildren || isRenewPending}
                  onClick={handleRenewClick(params.id as number)}
                />
              </span>
            </BootstrapTooltip>
          );
        }

        // فسخ قرارداد — فقط برای قراردادهای غیر فسخ‌شده
        if (canEdit("agreements") || canCreate("agreements")) {
          const isCanceled =
            params.row.agreementStatus === StatusGlobal.Canceled ||
            !!params.row.canceledOn;
          actions.push(
            <BootstrapTooltip
              title={
                isCanceled
                  ? "این قرارداد قبلاً فسخ شده است"
                  : "فسخ قرارداد"
              }
              key="agreement-cancel"
            >
              <span>
                <GridActionsCellItem
                  icon={
                    <CancelIcon
                      color={isCanceled || isCancelPending ? "disabled" : "error"}
                    />
                  }
                  label="فسخ قرارداد"
                  disabled={isCanceled || isCancelPending}
                  onClick={() => handleOpenCancelDialog(params.row)}
                />
              </span>
            </BootstrapTooltip>
          );
        }

        return actions;
      },
    },
    {
      field: "renewedFromAgreementRef",
      headerName: "نوع قرارداد",
      align: "center",
      headerAlign: "center",
      sortable: true,
      minWidth: 130,
      renderCell: (params: GridRenderCellParams) =>
        params.value != null
          ? `تمدید از #${params.value}`
          : "قرارداد اصلی",
    },
    {
      field: "customerRef",
      headerName: "مشتری",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 190,
      type: "singleSelect",
      valueOptions: getCustomers,
    },
    {
      field: "startedAt",
      headerName: "تاریخ شروع",
      align: "center",
      headerAlign: "center",
      editable: false, // تاریخ شروع معمولا تغییر نمی‌کند
      sortable: true,
      minWidth: 180,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "delayFactor",
      headerName: "ضریب تاخیر",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "number",
      minWidth: 150,
    },
    {
      field: "price",
      headerName: "مبلغ",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "number",
      minWidth: 150,
    },
    {
      field: "sessionCounter",
      headerName: "تعداد فصل",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "number",
      minWidth: 120,
    },

    {
      field: "createdOn",
      headerName: "تاریخ ایجاد",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
    {
      field: "modifiedOn",
      headerName: "تاریخ ویرایش",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
  ];

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "services/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async (agreeId: string) => {
      const response = await fetch(Routes.AgreementsRoutes + agreeId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const { mutateAsync: getServiceByIdAsync, isPending: getServiceByIdPending } =
    useMutation({
      mutationFn: async (id: string) => {
        const response = await fetch(Routes.ServicesRoutes + id, {
          method: "Get",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
        });
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log("eee", error);
      },
    });

  const {
    mutateAsync: getAppSystemByCustomerIdAsync,
    isPending: isAppSystemByCustomerIdPending,
  } = useMutation({
    mutationFn: async ({
      customerRef,
      systemRef,
    }: {
      customerRef?: string | undefined | null;
      systemRef?: number | undefined | null;
    }) => {
      const response = await fetch(
        API_URL +
          "appUser-websystem/by-customer/" +
          systemRef +
          "/" +
          customerRef,
        {
          method: "Get",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const {
    mutateAsync: getFollowupGroupByIdAsync,
    isPending: getFollowupGroupsByIdPending,
  } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(API_URL + "followup-groups/" + id, {
        method: "Get",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });
  const [agreementId, setAgreementId] = useState<number>();

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;

  const [anchorScheduleEl, setAnchorScheduleEl] =
    useState<HTMLButtonElement | null>(null);
  const openSchedulePopover = Boolean(anchorScheduleEl);
  const idSchedulePopover = openSchedulePopover ? "simple-popover" : undefined;
  const [openServiceReportDialog, setOpenServiceReportDialog] = useState(false);
  const handleSchedulePopoverClose = () => {
    setAnchorScheduleEl(null);
    // getAgreements();
  };
  const controller = new AbortController();
  const { mutateAsync: insertScheduleAsync, isPending: insertSchedulePending } =
    useMutation({
      mutationFn: async (body: any) => {
        const response = await fetch(API_URL + "followup-schedule", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json", // تغییر به application/json
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        console.log("🚀 ~ mutationFn: ~ response:", response);
        return await response.json();
      },
      onSuccess: (responseData) => {
        if (responseData.Status) {
          // داده‌های پاسخ را پردازش کنید
          console.log("Success:", responseData.Data); // FollowupScheduleFieldOnlyDto
          // مثال: به‌روزرسانی state یا نمایش پیام موفقیت
        } else {
          console.error("Error from server:", responseData.Data);
          // مثال: نمایش پیام خطا به کاربر
        }
      },
      onError: (error) => {
        console.error("Mutation error:", error);
        // مثال: نمایش پیام خطا به کاربر (مثلاً با toast)
      },
    });

  const { mutateAsync: insertWebSystem, isPending: systemLoading } =
    useMutation({
      mutationFn: async (body: any) => {
        const response = await fetch(API_URL + "appUser-websystem", {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
        });
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const handleCreateSchedule = async () => {
    //TODO اگر تاریخ پایان افتاد برج 12 خودش پیشفرض یک بچه بسازه با تاریخ 12/29

    //TODO امسال کبیسه این مشکل نداره سال بعد مشکل داره

    setIsLoading(true); // نمایش پروگرس بار
    handleSchedulePopoverClose();
    try {
      const agreement: IAgreement = await getAgreementById(agreementId ?? 0);

      if (agreement && agreement.services && agreement.services.length > 0) {
        // استفاده از Promise.all برای مدیریت فرآیندهای ناهمگام
        await Promise.all(
          agreement.services.map(async (row) => {
            const service: IService = row.serviceRef
              ? await getServiceByIdAsync(row.serviceRef.toString())
              : undefined;

            if (service && service.isFollowUp) {
              const serviceFirstFollowUpedOn = ConvertToShamsiDate(
                service?.firstFollowUpedOn?.toString()
              ).split("/");

              const agreementStartedAt = ConvertToShamsiDate(
                agreement?.startedAt?.toString()
              ).split("/");

              let customDate: string;
              if (
                serviceFirstFollowUpedOn &&
                serviceFirstFollowUpedOn.length > 0
              ) {
                customDate =
                  agreementStartedAt[0] +
                  "-" +
                  serviceFirstFollowUpedOn[1] +
                  "-" +
                  serviceFirstFollowUpedOn[2];
              } else {
                customDate =
                  agreementStartedAt[0] +
                  "-" +
                  serviceFirstFollowUpedOn[1] +
                  "-30";
              }

              const newDate = moment(customDate, "jYYYY/jMM/jDD");
              const startedOn = ConvertToMiladiDateDB(newDate.toString());
              const lastDayOfShamsiYear = moment(
                `${agreementStartedAt[0]}/12/29`,
                "jYYYY/jMM/jDD"
              );

              const isLeapYear = moment(
                `${agreementStartedAt[0]}-01-01`,
                "jYYYY-jMM-jDD"
              ).isLeapYear();
              const daysInYear = isLeapYear ? 366 : 365;
              if (daysInYear === 366) {
                lastDayOfShamsiYear.add(1, "day");
              }

              const lastDayOfMiladiYear =
                lastDayOfShamsiYear.format("YYYY-MM-DD");
              const endedOn = ConvertToMiladiDateDB(lastDayOfMiladiYear);
              const period = 1;
              const followUpType =
                service?.followUpType ?? FollowUpType.Monthly;
              const dates = calculateDates(
                startedOn,
                endedOn,
                followUpType,
                period
              );

              const followupGroup: IFollowUpGroups = row.followUpGroupRef
                ? await getFollowupGroupByIdAsync(
                    row.followUpGroupRef.toString()
                  )
                : undefined;

              const userSystem: IAppUserWebSystem =
                await getAppSystemByCustomerIdAsync({
                  customerRef: agreement.customerRef,
                  systemRef: service?.systemRef ?? 0,
                });

              const webSystem: IAppUserWebSystem = {
                customerRef: agreement.customerRef,
                systemRef: service?.systemRef,
                userName: "0",
                password: "0",
              };

              let systemRef;
              //@ts-ignore
              if (userSystem?.title === "Not Found") {
                const resSystem = await insertWebSystem(webSystem);
                systemRef = resSystem.data?.id;
              } else {
                systemRef = userSystem?.id;
              }

              const scheduleObject: IFollowupSchedule = {
                agreementRef: agreement?.id,
                parentRef: undefined,
                scheduleStatus: StatusGlobal.NotStarted,
                creatorRef: undefined,
                title: service.name,
                dueOn: undefined,
                period: period,
                isActive: true,
                isSMS: followupGroup?.isSendSMS,
                desc: row.desc,
                priroty: followupGroup?.priority,
                groupRef: followupGroup?.id,
                //@ts-ignore
                startedOn: ConvertToMiladiDateDB(startedOn),
                //@ts-ignore
                endedOn: ConvertToMiladiDateDB(endedOn),
                followUpType: followUpType,
                serviceRef: service?.id,
                systemRef: systemRef,
                customerRef: agreement.customerRef,
              };

              if (
                dates.length > 0 &&
                dates.some(
                  (date) => new Date(date) > new Date(agreement.startedAt ?? "")
                )
              ) {
                const res = await insertScheduleAsync(scheduleObject);
                if (res?.status === true) {
                  await Promise.all(
                    dates.map(async (date) => {
                      if (
                        agreement.startedAt &&
                        new Date(date) > new Date(agreement.startedAt)
                      ) {
                        const res2 = await insertScheduleAsync({
                          ...scheduleObject,
                          parentRef: res.data?.id,
                          dueOn: date,
                        });
                      }
                    })
                  );

                  handleSendMessage(
                    notifications,
                    "دوره پیگیری برای این قرار داد با موفقیت ایجاد شد",
                    "success"
                  );
                } else {
                  handleSendMessage(
                    notifications,
                    "خطا در ایجاد دوره پیگیری",
                    "error",
                    3000,
                    service.id.toString()
                  );
                }
              } else {
                handleSendMessage(
                  notifications,
                  "هیچ تاریخی برای ایجاد پیگیری دوره‌ای وجود ندارد",
                  "error",
                  3000,
                  service.id.toString()
                );
              }
            }
          })
        );
      } else {
        handleSendMessage(
          notifications,
          "قرارداد هیچ خدمات مرتبطی ندارد",
          "error",
          5000,
          "notService"
        );
      }
    } catch (error) {
      console.error("Error in schedule process:", error);
      handleSendMessage(
        notifications,
        "خطا در پردازش پیگیری‌ها",
        "error",
        5000,
        "processError"
      );
    } finally {
      setIsLoading(false); // مخفی کردن پروگرس بار
    }
  };

  const handleScheduleClick = async (
    event: MouseEvent<HTMLButtonElement>,
    id: number
  ) => {
    setAnchorScheduleEl(event.currentTarget);
    setAgreementId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync(agreementId?.toString() ?? "0");
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      getAgreements();
    }
    handleDeletePopoverClose();
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        {canCreate("agreements") && (
          <Button
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setOpenNewAgreement(true)}
          >
            قرارداد جدید
          </Button>
        )}
        {canView("reports") && (
          <Button
            color="secondary"
            startIcon={<AssessmentIcon />}
            onClick={() => setOpenServiceReportDialog(true)}
          >
            گزارش خدمات قراردادها
          </Button>
        )}
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: number) => () => {
    setAgreementId(id);
    setOpenNewAgreement(true);
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      user?.token && getAgreements();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleClose = () => {
    setOpenAgreementInfo(false);
    setAgreementId(undefined);
  };
  const quickFilterRef = useRef<HTMLInputElement>(null);
  const [quickFilterValue, setQuickFilterValue] = useState<string>("");
  const quickFilterValueRef = useRef<string>(""); // برای ذخیره مقدار
  const [tempFilterValue, setTempFilterValue] = useState<string>(""); // مقدار موقت برای تایپ

  // هندل کردن تغییر مقدار ورودی (لحظه‌ای)
  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setTempFilterValue(event.target.value); // ذخیره مقدار موقت
    },
    []
  );

  // هندل کردن کلید Enter برای اجرای جستجو
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      event.stopPropagation(); // جلوگیری از پخش رویداد
      if (event.key === "Enter") {
        event.preventDefault(); // جلوگیری از رفتار پیش‌فرض Enter
        setQuickFilterValue(tempFilterValue); // انتقال مقدار موقت به مقدار نهایی برای جستجو
      }
    },
    [tempFilterValue]
  );
  useEffect(() => {
    let active = true;

    (async () => {
      if (user && user?.token) {
        setLoading(true);
        try {
          await getAgreements();
          if (active) {
            await getCustomersData();
          }
        } catch (error) {
          console.error("Error in initial fetch:", error);
        }
        if (active) {
          setLoading(false);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [
    user?.token,
    paginationModel.page,
    paginationModel.pageSize,
    quickFilterValue,
    getAgreements,
    getCustomersData,
  ]);

  useEffect(() => {
    if (quickFilterRef.current) {
      quickFilterRef.current.focus();
    }
  }, [quickFilterValue]);
  //const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });
  return (
    <>
      <PageTitle title="قراردادها" />
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <PopoverComponent
        caption=" پیگیری برای این قرار داد ایجاد شود ؟"
        anchorEl={anchorScheduleEl}
        handlePopoverClose={handleSchedulePopoverClose}
        handler={handleCreateSchedule}
        id={idSchedulePopover}
        isLoading={false}
        open={openSchedulePopover}
        key="schedule-confirm-popover"
      />

      <NewAgreement
        customers={getCustomers}
        open={openNewAgreement}
        setOpen={setOpenNewAgreement}
        refetch={getAgreements}
        agreementId={agreementId}
        setAgreementId={setAgreementId}
        isEdit={!!agreementId}
        // data={rowInfo}
      />
      <ShowAgreementInfo
        agreement={getAgreeServices}
        handleClose={handleClose}
        open={openAgreementInfo}
      />

      <AgreementServiceReportDialog
        open={openServiceReportDialog}
        onClose={() => setOpenServiceReportDialog(false)}
      />

      <Dialog open={openCancelDialog} onClose={handleCloseCancelDialog}>
        <DialogTitle>فسخ قرارداد</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            تاریخ فسخ قرارداد را انتخاب کنید. تمام پیگیری‌های مرتبط با این قرارداد
            که تاریخ آن‌ها برابر یا بعد از این تاریخ باشد، به وضعیت لغو شده (Canceled)
            تغییر داده می‌شوند.
          </Typography>
          <DatePicker
            label="تاریخ فسخ قرارداد"
            value={cancelDate}
            onChange={(date: Date | null) => setCancelDate(date)}
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCancelDialog} color="inherit">
            انصراف
          </Button>
          <Button
            onClick={handleConfirmCancel}
            color="error"
            disabled={!cancelDate || isCancelPending}
          >
            {isCancelPending ? "در حال ثبت..." : "تأیید فسخ"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {(isPendingAgreements ||
          isAppSystemByCustomerIdPending ||
          isDeleteLoading ||
          isEditLoading ||
          isPending ||
          isPendingAgreementById ||
          isPendingCustomers) && <LinearProgress />}

        <DataGrid
          columns={columns}
          loading={isLoading || isEditLoading}
          //EditToolbar={EditToolbar}
          rowModesModel={rowModesModel}
          //sortFields={{ field: "modifiedOn", sort: "desc" }}
          processRowUpdate={processRowUpdate}
          rows={rows}
          //setRowModesModel={setRowModesModel}
          //gridUniqueName="Agreements"
          slots={{
            toolbar: () => (
              <Stack direction={"row"} justifyContent={"space-between"}>
                <GridToolbar />
                <Stack direction={"row"} alignItems={"center"} spacing={2}>
                  <EditToolbar />
                  <GridToolbarQuickFilter
                    ref={quickFilterRef}
                    value={tempFilterValue} // نمایش مقدار موقت
                    onChange={handleInputChange} // به‌روزرسانی مقدار موقت
                    onKeyDown={handleKeyDown} // مدیریت کلید Enter
                    inputProps={{
                      autoFocus: true,
                    }}
                  />
                </Stack>
              </Stack>
            ),
          }}
          slotProps={{
            toolbar: {
              printOptions: {
                getRowsToExport: true,
              },
              csvOptions: {
                utf8WithBom: true,
              },
              showQuickFilter: true,
              quickFilterProps: {
                debounceMs: 500, // کاهش زمان تأخیر برای جستجو
              },
            },
          }}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          pageSizeOptions={[25, 50, 100]}
          rowCount={rowCount}
          onPaginationModelChange={setPaginationModel}
          checkboxSelection
          //onRowSelectionModelChange={setRowSelectionModel}
          //rowSelectionModel={rowSelectionModel}
          keepNonExistentRowsSelected
          filterModel={{ items: [] }}
          //disableSelectionOnClick
        />
      </Box>
    </>
  );
};

export default Agreements;
